import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { totemModeService } from '../../../shared/services/totemModeService';
import { totemNeedsReconnect } from '../../../shared/services/totemSessionRecovery';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        // Totem com sessão morta: QR de reconexão, não login de usuário
        if (totemModeService.isTotemMode() || totemNeedsReconnect()) {
            return <Navigate to="/televisao" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
